import _ from "lodash";
import React from "react";
import { Divider, Select } from "antd";
import {
  cleanElementName,
  getPropertyDefaultValue,
  splitElementKey,
} from "../../lib/helpers";
import StepButton from "../../lib/StepButton";
import { useDispatch, useSelector } from "react-redux";
import Upload from "../../lib/Upload";
import { setBgFiles } from "../../services/store";

const Property = ({
  selectedElement,
  isGlobal,
  globalProperties,
  localProperties,
  handlePropertyChange,
  property,
  isColor = false,
}) => {
  const dispatch = useDispatch();
  const { bgFiles = [] } = useSelector((state) => state.grid);
  const { options = [], label, key, type = "select" } = property;
  const { element } = splitElementKey(selectedElement);

  const globalValue = _.get(globalProperties, [cleanElementName(element), key]);
  const localValue = _.get(localProperties, [selectedElement, key]);

  const value = isGlobal ? globalValue : localValue;

  const flattenedOptions = options.flatMap((f) =>
    f.options ? f.options : [f],
  );

  return (
    <div className="flex flex-col items-start gap-1">
      <div className="flex items-center gap-1 justify-between w-full">
        <label className="text-xs font-bold">{label}</label>
        {type === "select" ? (
          <StepButton
            type="dots"
            value={value}
            values={flattenedOptions.map((o) => o.value)}
            showValue={false}
            onChange={(value) => handlePropertyChange(key, value)}
          />
        ) : null}
      </div>
      {type === "file" ? (
        <Upload
          files={bgFiles}
          onChange={(files) => dispatch(setBgFiles(files))}
        />
      ) : (
        <Select
          options={options}
          onChange={(value) => {
            if (!value) return;
            handlePropertyChange(key, value);
          }}
          value={value}
          className="w-full"
          placeholder={globalValue}
          allowClear
          onClear={() =>
            handlePropertyChange(
              key,
              getPropertyDefaultValue(key, selectedElement),
            )
          }
          popupRender={(menu) =>
            isColor ? (
              <>
                {menu}
                <Divider className="my-2" />
                <div className="flex flex-wrap gap-1 p-2">
                  {flattenedOptions.map((option) => {
                    const split = option.value.split("-");
                    const color = `bg-${split.slice(1).join("-")}`;
                    return (
                      <div
                        key={option.value}
                        title={option.value}
                        onClick={() => handlePropertyChange(key, option.value)}
                        className={`flex h-6 w-6 rounded cursor-pointer hover:outline hover:outline-solid hover:outline-teal-800 ${color}`}
                      ></div>
                    );
                  })}
                </div>
              </>
            ) : (
              menu
            )
          }
        />
      )}
    </div>
  );
};

export default Property;
